<template>
  <van-form ref="form" :validate-first="true" :show-error-message="false">
    <van-field
      v-model="username"
      disabled
      name="账户名称"
      label="账户名称"
      placeholder="请输入账户名称"
      :rules="[{ required: true, message: '请填写账户名称' }]"
    />
    <van-field
      v-model="password"
      type="password"
      name="新密码"
      label="新密码"
      placeholder="请输入新密码"
      :rules="[{ required: true, message: '请填写新密码' },{ validator:validateToNextPassword, message: '请输入正确内容' }]"
    />
    <van-field
      v-model="confirmpassword"
      type="password"
      name="确认密码"
      label="确认密码"
      placeholder="请输入确认密码"
      :rules="[{ required: true, message: '请填写确认密码' },{ validator:compareToFirstPassword, message: '请输入正确内容' }]"
    />
    <div style="margin: 16px;">
      <van-button round block type="info"  @click="handleSubmit">保存</van-button>
    </div>
  </van-form>
</template>

<script>

import { Toast } from 'vant'
export default {
  name: 'SetPassword',
  data () {
    return {
      username: '',
      password: '',
      confirmpassword: ''
    }
  },
  created () {
    this.username = this.$route.params.username
  },
  methods: {
    handleSubmit () {
      // 触发表单验证
      this.$refs.form.validate().then(() => {
        const formData = {
          username: this.username,
          password: this.password,
          confirmpassword: this.confirmpassword
        }
        this.$api.user.changePassword(formData).then((res) => {
          if (res.success) {
            Toast.success(res.msg)
          } else {
            Toast.fail(res.msg)
          }
        })
      }).catch((ex) => {
        console.log('验证失败', ex)
      })
    },
    validateToNextPassword  (value) {
      if (/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,./]).{8,}$/.test(value)) {
        if (value && this.confirmpassword && value !== this.confirmpassword) {
          Toast.fail('两次输入的密码不一样！')
          return false
        }
      } else {
        Toast.fail('密码由8位数字、大小写字母和特殊符号组成!')
        return false
      }
      return true
    },
    compareToFirstPassword  (value) {
      if (value && value !== this.password) {
        Toast.fail('两次输入的密码不一样！')
        return false
      } else {
        return true
      }
    }
  }
}
</script>
